// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__18mba","itemTitle":"ClientEmergencyInfo_itemTitle__2XEe0","itemText":"ClientEmergencyInfo_itemText__1aLuU"};